import Button from 'components/shared/button';
import InputField from 'components/shared/input-field';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveFormData } from 'store/slices/houseRent';
import { v4 as uuid } from 'uuid';
import { Step2Props, Step3Types, step3ValidationSchema } from './utils';
import { useAppSelector } from 'store/hooks';
import { formatWithCommas } from 'functions/currencyConveter';

const Step3 = ({ prevStep, handleInputDataUpdate, nextStep }: Step2Props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const saved = useAppSelector((s) => s.houseRent.formData.step3);
  const applicationId = useAppSelector(
    (state) => state.houseRent.applicationId
  );

  const initialValues: Step3Types = {
    Occupation: saved?.Occupation ?? '',
    CompanyName: saved?.CompanyName ?? '',
    YearsOfWork: saved?.YearsOfWork ?? '',
    CompanyEmail: saved?.CompanyEmail ?? '',
    CompanyPhoneNumber: saved?.CompanyPhoneNumber ?? '',
    CompanyLocation: saved?.CompanyLocation ?? '',
  };

  const formik = useFormik<Step3Types>({
    initialValues,
    validationSchema: step3ValidationSchema,
    validateOnMount: true,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const id = applicationId || uuid();

        dispatch(
          saveFormData({
            applicationId: id,
            formData: values,
            step: 'step3', // ✅ FIXED
          })
        );
        handleInputDataUpdate(values);
        nextStep();
      } catch (err) {
        console.error('Save & Continue (Step 3) failed:', err);
      } finally {
        setLoading(false);
      }
    },
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const plainValue = value.replace(/,/g, '');
    if (name === `RentPrice`) {
      const formattedValue = formatWithCommas(plainValue);
      formik.setFieldValue(`RentPrice`, formattedValue);
      formik.handleChange(e);
    } else {
      formik.handleChange(e);
    }
    // formik.handleChange(e);
  };

  return (
    <form>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div className="col-span-1">
          <InputField
            label="Occupation/Business"
            type="text"
            name="Occupation"
            placeholder="Occupation/Business"
            value={formik.values.Occupation}
            onChange={handleInputChange}
            onBlur={formik.handleBlur}
            required
            error={formik.errors.Occupation}
          />
        </div>
        <div className="col-span-1">
          <InputField
            label="Company/Business Name"
            type="text"
            name="CompanyName"
            placeholder="Company/Business Name"
            value={formik.values.CompanyName}
            onChange={handleInputChange}
            onBlur={formik.handleBlur}
            required
            error={formik.errors.CompanyName}
          />
        </div>

        <div className="col-span-1">
          <InputField
            label="Company/Business Email"
            type="email"
            name="CompanyEmail"
            placeholder="Company/Business Email"
            value={formik.values.CompanyEmail}
            onChange={handleInputChange}
            onBlur={formik.handleBlur}
            required
            error={formik.errors.CompanyEmail}
          />
        </div>
        <div className="col-span-1">
          <InputField
            label="Company/Business Location"
            type="text"
            name="CompanyLocation"
            placeholder="Company/Business Location"
            value={formik.values.CompanyLocation}
            onChange={handleInputChange}
            onBlur={formik.handleBlur}
            required
            error={formik.errors.CompanyLocation}
          />
        </div>
        <div className="col-span-1">
          <InputField
            label="Years of Work"
            type="number"
            name="YearsOfWork"
            placeholder="Years of Work"
            value={formik.values.YearsOfWork}
            onChange={handleInputChange}
            onBlur={formik.handleBlur}
            required
            error={formik.errors.YearsOfWork}
          />
        </div>
        <div className="col-span-1">
          <InputField
            label="Company/Business Phone Number"
            type="text"
            name="CompanyPhoneNumber"
            placeholder="Company/Business Phone Number"
            value={formik.values.CompanyPhoneNumber}
            onChange={handleInputChange}
            onBlur={formik.handleBlur}
            required
            error={formik.errors.CompanyPhoneNumber}
          />
        </div>
      </div>

      <div className="w-full justify-between flex items-center mt-10">
        <Button
          type="button"
          onClick={prevStep}
          className="bg-white border text-BrandPrimary border-BrandPrimary"
        >
          Back
        </Button>

        <Button
          type="button"
          onClick={() => formik.handleSubmit()}
          disabled={loading || !formik.isValid}
        >
          {loading ? 'Saving...' : 'Save and Continue'}
        </Button>
      </div>
    </form>
  );
};

export default Step3;
